"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFilter = exports.isHighlightOnly = exports.isPrefix = void 0;
const enums_1 = require("./enums");
function isPrefix(keyword) {
    return keyword.searchLogic === enums_1.SearchLogic.PrefixMatch;
}
exports.isPrefix = isPrefix;
function isHighlightOnly(keyword) {
    return keyword.filterLogic === enums_1.FilterLogic.HighlightOnly;
}
exports.isHighlightOnly = isHighlightOnly;
function isFilter(keyword) {
    return keyword.filterLogic === enums_1.FilterLogic.Filter;
}
exports.isFilter = isFilter;
